import BaseStore from '@src/utils/store/base-store';
import { observable } from 'mobx';
import { autobind } from 'core-decorators';
import { useRequest } from 'ahooks';
import cmsApi from '@src/services/cms-api';
import { CMS_CATEGORY_ID, CMS_API, ARTICLE_ID } from '@src/constants/articles';

class ComponentStore extends BaseStore {
  // 内页单篇 CMS 内容（HTML，内含写死 id 锚点小节）
  @observable contentHtml = '';

  @autobind
  async fetchArticleDetailAsync() {
    return cmsApi.getArticleDetail({
      categoryId: CMS_CATEGORY_ID,
      articleId: ARTICLE_ID.BURDEN_OPTIMIZATION,
      api: CMS_API
    });
  }

  use(props) {
    super.use(props);

    useRequest(this.fetchArticleDetailAsync, {
      onSuccess: res => {
        // 归一化为稳定 ViewModel：getArticleDetail 返回单个对象，防御兼容数组，空值兜底
        const detail = Array.isArray(res) ? res[0] : res;
        this.contentHtml = (detail && detail.content) || '';
      }
    });
  }
}

export default ComponentStore;
